export const MuiIconButton = {
  styleOverrides: {
    root: {
      borderRadius: '5px',
      fontSize: '1.3em !important',
      '&.icon-button-base': {
        borderRadius: '5px',
        border: '0.5px solid rgba(201, 209, 217,0.6)',
        color: 'rgb(201, 209, 217)',
        backgroundColor: 'rgb(33, 38, 45)',
        '&:hover': {
          border: '0.5px solid rgba(201, 209, 217,0.9)',
        },
      },
      '&.no-border': {
        height: '18px',
        border: 'none',
        width: '18px',
        color: 'inherit',
        padding: '0',
      },
    },
    sizeSmall: {
      width: '24px',
      height: '24px',
    },
    sizeMedium: {
      width: '40px',
      height: '40px',
    },
    sizeLarge: {
      width: '50px',
      height: '50px',
    },
  },
}
